// todo move this file to module
export let showUsersOrdersInMainDashboard = {
    '1': 'فعال',
    '0': 'غیرفعال',
}